import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, ProgressBar } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait1 from './svg/wait1.svg'
import svgWait2 from './svg/wait2.gif'

import i18next from 'i18next';

import { SystemHeader } from './CommonUI';
import { BcanConfig } from './Types';

interface RptRstInfo {
    Rst_Key: string,
    Rst_Line: string,
}

interface StkNo {
    StkNo1: string,
    StkNo2: string,
    StkNo3: string,
    StkNo4: string,
    StkNo5: string,
    StkNo6: string,
    StkNo7: string,
    StkNo8: string,
    StkNo9: string,
    StkNo10: string,
    StkNo11: string,
    StkNo12: string,
    StkNo13: string,
    StkNo14: string,
    StkNo15: string,
    StkNo16: string,
    StkNo17: string,
    StkNo18: string,
    StkNo19: string,
    StkNo20:string,
    StkNo21:string,
    StkNo22:string,
    StkNo23:string,
    StkNo24:string,
    StkNo25:string,
    StkNo26:string,
    StkNo27:string,
    StkNo28:string,
    StkNo29:string,
    StkNo30:string,      
}

interface PageInfo {
    n: number
}

var GsbFlag: any;

//CCRGenRecDateMain
interface CCRGenRecDateMainProps {
    gsb: AxiosInstance  
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function CCRGenRecDateMain({ gsb }: CCRGenRecDateMainProps) {

    let ProgressId2 = ""
    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />
    
    const { t, i18n } = useTranslation();

    const [ProgressId, setProgressId] = useState("")
    const [ProgressValue, setProgressValue] = useState(0)

    const [Rstdata, setRstdata] = useState([] as RptRstInfo[])
    const [Rstdata2, setRstdata2] = useState([] as RptRstInfo[])
    const [RptHead1, setRptHead1] = useState("")
    const [RptName, setRptName] = useState("")
    const [ExecelFile,setExcelFile] =  useState("")
    const [RptNameNo, setRptNameNo] = useState(0)
    const [aRptNameNo, setaRptNameNo] = useState([] as PageInfo[])
    const [RptLogName, setRptLogName] = useState("")
    const [RptLogName2, setRptLogName2] = useState("")
    
    const [ShowWait, setShowWait] = useState(false)
    const [ShowRpt, setShowRpt] = useState(false)
    const [ShowNoRecord, setShowNoRecord] = useState(false)
    const [ShowOK, setShowOK] = useState(true)
 
    const [s_ClCode1, sets_ClCode1] = useState("")
    const [s_ClCode2, sets_ClCode2] = useState("")
    const [DataFormatValue, setDataFormatValue] = useState(true)
    const [CSVFormat, setCSVFormat] = useState("0")
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    //const [cPrintMode, setcPrintMode] = useState("PS")

    const [LineLimit, setLineLimit] = useState(54 - 7)

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [Enter2tab, setEnter2tab] = useState("Y")

    const [NoOfSubmission, setNoOfSubmission] = useState("1")
    const [DateOfSubmission, setDateOfSubmission] = useState("")



    const [DateOfTrans, setDateOfTrans] = useState("")


    const [s_Date1, sets_Date1] = useState(utils.formatNumber(new Date()))
    const [s_Date2, sets_Date2] = useState(utils.formatNumber(new Date()))

 
    const [currentAc, setCurrentAc] = useState({} as BcanConfig) 
  
    const[GSBx_USER,setGSBx_USER] = useState(false)
    const[HKIDR_USER1,setHKIDR_USER1] = useState(false)


    const [OwnRefNoValue,setOwnRefNoValue] = useState("1234")
    const [FileIndicatorValue,setFileIndicatorValue] = useState("1")
    const [DateOfUpload, setDateOfUpload] = useState("")

    useEffect(() => {
        (async () => {
            try {
             
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SmMastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("SmMastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("SmMastMain disp GsbFlag: ", GsbFlag)
                //console.log("SmMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("SmMastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("SmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
} else {
    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
}
                setGSBx_USER(GsbFlag.GSBx_USER);
                setHKIDR_USER1(GsbFlag.HKIDR_USER1);
                setEnter2tab(GsbFlag.Enter2tab) ;
                setCSVFormat(GsbFlag.CSVFormat) ;
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    
    useEffect(() => {
        setShowRpt(false)
        setShowNoRecord(false)
        setShowOK(true)
    }, [s_Date1, s_Date2, DateOfTrans, FileIndicatorValue, OwnRefNoValue, DataFormatValue])
/*
    useEffect(() => {

        setnPage(1)
        if ( nPage > 0 ) {
            //setcPrintMode("PS")
        } 

        (async () => {
            try {
                // usually A/E code is prefixed with C, but some user may use others e.g. Upbest uses A for A/E
                // TODO: Read A/E prefix from config
                // fixed can read true A/E
                const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,
                                    filters: {
                            }
                        },
                        cPgmId: "BcanConfig",
                        cAction: "ListRec",
                    });
             
                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                  
                }              

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
 */
 

    useEffect(() => {
        (async () => {
            try {
               
                const res = await gsb.post('/Master',
                {   sb_data: {
                    },
                    cPgmId: "CCRMast",
                    cAction: "GetUploadDate",
                });    

                if ( res.data.count > 0 ) {
                    setDateOfUpload(res.data.data[0].d_Upload_DATE)                   
                    //setDateOfTrans(res.data.data[0].d_TRAN_DATE) 
                    sets_Date1(res.data.data[0].d_TRAN_DATE)
                    sets_Date2(res.data.data[0].d_TRAN_DATE)

                } else {

                }
            } catch (error) {
                //setCanPorcess(false)
                showError(error)
            }
        })()

    }, [gsb, TRAN_DATE, SETL_DATE])
 

    useEffect(() => {
        const refreshTasks = async () => {
            ProgressId2 = ProgressId
            if ( ProgressId2.trim().length > 0 ) {
                try {
                    const res = await gsb.post('/Progresslist', {p_data: ProgressId2})
                    let pValue = 0
                    if ( res.data.count > 0 ) {
                        if ( res.data.data[0].id === ProgressId2 ) {
                            pValue = res.data.data[0].progressValue / res.data.data[0].progressMax
                            //console.log("Progresslist: ", res.data.data[0].progressValue, res.data.data[0].progressMax) 
                            //console.log("Progresslist pValue: ", pValue) 
                            setProgressValue(pValue)
                        }
                        if (res.data.data[0].status > 0 ) {
                            clearInterval(timer)
                        }
                    }
                } catch (error) {
                    utils.showError(error)
                }
            }
        }
        let timer = setInterval(refreshTasks, 20*1000)
        return () => {clearInterval(timer)}
    }, [gsb, ProgressId, nPage])

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

  

        setShowOK(false)
        setShowWait(true)
        setShowNoRecord(false)
        setShowRpt(false)
        setRstdata([])
        setRptHead1("")
        setRptName("")
        
        setExcelFile("")

        setRptLogName2("")
        setRptLogName("")

        setnPage(1)
        ProgressId2 = utils.genUUID()
        setProgressId(ProgressId2)
        setProgressValue(0)

        if ( nPage > 0 ) {
            //setcPrintMode("PS")
        } 

        (async () => {
            try {
                //console.log("HkidrBcanMappingMain onsubmit called", data)
                const res = await gsb.post('/Master',
                    {    sb_data: {
                        ProgressId: ProgressId2,
                        s_Date1 : s_Date1,
                        s_Date2 : s_Date2,                    
                        s_RptName: RptName,   
                        s_ExecelFile: ExecelFile,                                   
                        s_OwnRefNoValue : OwnRefNoValue,         
                        s_DateOfUploadDate: DateOfUpload,
                        s_FileIndicatorValue: FileIndicatorValue,
                        DataFormat: DataFormatValue,
                        nPage: nPage,
                        cPrintMode: "PS",
                        limit: LineLimit,
                        },
                        cPgmId: "CCRMast",
                        cAction: "GenByStkRecordDate",
                    });

                //console.log("res.data.data: ", res.data.data) 
                if ( res.data.count > 0 ) {
                    setRstdata2([])
                    for (let j = 0; j < res.data.Rptdata.length; j++) {
                        Rstdata2.push({Rst_Key: res.data.Rptdata[j][0], Rst_Line: res.data.Rptdata[j][1]})
                    }
                    setShowWait(false)
                    setShowNoRecord(false)
                    setShowRpt(true)
                    setRstdata(Rstdata2)
                    console.log("Rstdata: ", Rstdata) 
                    setRptHead1(res.data.Rpthead1)
                    setRptName(res.data.RptName)
                    setExcelFile(res.data.ExecelFile)
                
                    setRptLogName(res.data.RptLogName)
                    setRptLogName2(res.data.RptLogName2)
                    setRptNameNo(res.data.RptNameNo)
                    //console.log("RptName: ", RptName) 
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(res.data.TotalPageNo)
                        for ( let j = 1; j <= res.data.TotalPageNo; j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                        if (res.data.RptNameNo > 0 ) {
                            for ( let j = 1 ; j <= res.data.RptNameNo; j++ ){
                                aRptNameNo.push({n: j});
                            }
                            setRptName(res.data.RptName.replace(".pdf",""))
                        }
                    }
                } else {
                    setShowWait(false)
                    setShowNoRecord(true)
                    setShowRpt(false)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }

 
    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }
    const Banner_OTCR2 =  
    <H3>Generate "CORP COMM RECIPIENT" By Record Date</H3>
  

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>



    let RptNameaRef = <>
        { RptNameNo > 0 && <div> Download / Print &nbsp;
            {aRptNameNo.map((no, j) => 
                <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}-${no.n}.pdf`}> <span id="RPageNo2" onClick={() => {} }> {no.n} &nbsp; </span> </a>
            )}
        </div> }
        { RptNameNo <= 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download / Print </a>}
    </>

    let list = <>
        <div className="Spacing-V-16" />
        {RptName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download Text</a>}
        &nbsp; &nbsp; {ExecelFile.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${ExecelFile}`}>Download Excel</a>} &nbsp;  &nbsp;{RptLogName2.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/logdownload?filename=${RptLogName2}&inline`}>View CCR file log</a>}

        &nbsp; &nbsp; {<a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/logdownload?filename=${RptLogName}&inline`}>View Log</a>} &nbsp; &nbsp;
   
        {ShowRpt && ! DataFormatValue && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead id="rpt_th_r">
                <tr >
                    { ! DataFormatValue && <th className="RCol-Head_p">
                            {RptName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download</a>}
                        </th>
                    }
                </tr>                    
                <tr>
                    <td className="RCol-Head1">{RptHead1}</td>
                </tr>                    
            </thead>
            <tbody id="rpt_tr">
                {Rstdata.map((rpt, i) =>
                    <tr key={i} onDoubleClick={() => { }}>
                        <td className="RCol-Rpt" onClick={() => {  }}>{rpt.Rst_Line}</td>
                    </tr>
                )}
            </tbody>
            <div className="Spacing-V-16" />
            {ShowRpt && ! DataFormatValue && Pagination}
        </HTMLTable>
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>
            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >

                    {/*<H3>Export OTCR Reporting File (D/W only) in History (Selected Trans date: {DateOfTrans}) </H3>*/}
                    {Banner_OTCR2}
                    <div className="Spacing-V-16" />
                   
                    <div className="Row"> 
             
                        <FormGroup className="Col-1-2" label={t('Start Record Date from')} labelFor="inputStkRecordDate1">
                            <InputGroup   id="inputDoB" name="s_Date1" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" value={s_Date1}    onChange={utils.handleStringChange(s => sets_Date1(s))} />      
                        </FormGroup>
                        <FormGroup className="Col-3-2" label={t('Start Record Date from')} labelFor="inputStkRecordDate2">
                            <InputGroup   id="inputDoB" name="s_Date2" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" value={s_Date2}     onChange={utils.handleStringChange(s => sets_Date2(s))} />      
                        </FormGroup>  
                        
                        <FormGroup className="Col-1-2" label="Own Ref No." labelFor="inputNoOfSubmission">
                        <InputGroup
                            id="inputNoOfSubmission"
                            autoFocus
                            placeholder="Own Ref No..."
                            value={OwnRefNoValue}
                            onChange={utils.handleStringChange(s => setOwnRefNoValue(s))}
                        />                    
                        </FormGroup>

                        <FormGroup className="Col-1-2" label={t('Upload Date')} labelFor="inputUpload_Date">
                            <InputGroup   id="inputDoB" name="d_Upload_Date" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" defaultValue={DateOfUpload}    onChange={utils.handleStringChange(s => setDateOfUpload(s))} />      
                        </FormGroup>

                        <FormGroup className="Col-1-2" label="File Indicator" labelFor="inputFileIndicator">
                        <InputGroup
                            id="inputFileIndicator"
                            autoFocus
                            placeholder="File Indicator..."
                            value={FileIndicatorValue}
                            onChange={utils.handleStringChange(s => setFileIndicatorValue(s))}
                        />                    
                        </FormGroup>



                        {currentAc.d_OTCR_FileType == "TXT" &&
                        <FormGroup className="Col-1-2" >
                            <div>Text Format</div>
                        </FormGroup>}
                        {currentAc.d_OTCR_FileType == "ZIP" &&
                        <FormGroup className="Col-1-2" >
                            <div>ZIP Format</div>
                        </FormGroup>}
                    </div>
                    <div className="Row">
                        <Button disabled={! ShowOK} type="submit">OK</Button>
                    </div>
                </Card>
                {/* {ShowWait && <div>{imgWait}</div> } */}
                {ShowWait && <div className="TCol-Progress2">Progress ...</div> }
                {ShowWait && <div className="TCol-Progress2"><ProgressBar stripes={false} animate={false} value={ProgressValue} /></div> }
                {ShowNoRecord && <p>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <FormGroup className="Col-1-3"  >
                            <span id="Err_msg">No Record found !!!</span>
                        </FormGroup>
                    </div>
                </p>
                }
                {ShowRpt && list}
            </form>
        </>
    );
}
 
export default CCRGenRecDateMain